import { INVOICE_ACTIVITY_QUERY } from "@/apis/gql/apolloClient";
import type { InvoiceActivity } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { useQuery } from "@apollo/client";

export const useGetInvoiceActivity = ({
  invoiceId,
  fetchPolicy,
}: { invoiceId: string; fetchPolicy?: "network-only" }) => {
  const { tenantId } = useTenant();
  const { data, error, loading, refetch } = useQuery<{
    invoiceActivity: InvoiceActivity[];
  }>(INVOICE_ACTIVITY_QUERY, {
    variables: { tenantId, invoiceId },
    fetchPolicy,
  });

  return {
    invoiceActivity: data?.invoiceActivity ?? [],
    error,
    loading,
    refetch,
  };
};
